module.exports = __webpack_public_path__ + "Roboto-Medium.574fd0b50367f886d359.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Medium.woff2
// module id = ../../../../../font/roboto/Roboto-Medium.woff2
// module chunks = styles